import React, { useMemo } from 'react';
import { useStyle } from '@magento/venia-ui/lib/classify';
import defaultClasses from './tearsheetPDF.module.css';
import Price from '@magento/venia-ui/lib/components/Price';
import InfoIcon from '/src/assets/info-icon-large-activated.svg';
import Icon from '@magento/venia-ui/lib/components/Icon';
import { generateUrl } from '@magento/peregrine/lib/util/imageUtils';
var TEARSHEET_IMAGE_WIDTH = 1800;

var BaseInfo = function BaseInfo(_ref) {
  var _pdfData$price, _pdfData$price$toLowe, _product$price_range, _product$price_range$, _product$price_range$2, _pdfData$price2, _pdfData$price2$toLow, _product$price_range2, _product$price_range3, _product$price_range4, _product$price_range5, _product$price_range6, _product$price_range7;

  var propClasses = _ref.classes,
      product = _ref.product,
      optionSelections = _ref.optionSelections,
      itemId = _ref.itemId,
      smartString = _ref.smartString,
      productDetails = _ref.productDetails,
      pdfData = _ref.pdfData;
  var classes = useStyle(defaultClasses, propClasses);
  var isConfigurable = (product === null || product === void 0 ? void 0 : product.__typename) === 'ConfigurableProduct';
  /**
   * makes an array of configured options
   */

  var selectedOptions = useMemo(function () {
    var _product$configurable;

    var selections = [];
    product === null || product === void 0 ? void 0 : (_product$configurable = product.configurable_options) === null || _product$configurable === void 0 ? void 0 : _product$configurable.forEach(function (option) {
      var _option$values;

      var optionId = optionSelections.get(option === null || option === void 0 ? void 0 : option.attribute_id);
      var selectedOption = option === null || option === void 0 ? void 0 : (_option$values = option.values) === null || _option$values === void 0 ? void 0 : _option$values.find(function (value) {
        return value.value_index === optionId;
      });
      selections.push({
        label: option === null || option === void 0 ? void 0 : option.label,
        value: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label
      });
    });
    return selections;
  }, [product, optionSelections]);
  var imageSrc = generateUrl(product === null || product === void 0 ? void 0 : product.small_image, 'image-product')(TEARSHEET_IMAGE_WIDTH);
  return React.createElement("div", {
    className: classes.baseInfo
  }, React.createElement("img", {
    src: imageSrc,
    alt: 'product image',
    className: 'mr-4'
  }), React.createElement("div", {
    className: classes.rightSide
  }, React.createElement("h5", null, product === null || product === void 0 ? void 0 : product.name), React.createElement("div", {
    className: "flex my-[5px]"
  }, React.createElement("p", {
    className: "font-bold"
  }, "Base Item #:"), React.createElement("p", {
    className: "ml-1"
  }, product.sku)), isConfigurable && selectedOptions && React.createElement(React.Fragment, null, React.createElement("h5", {
    className: classes.bottomBorder
  }, "Selected Options"), React.createElement("div", {
    className: classes.selectedOptions
  }, selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.map(function (option) {
    return React.createElement("p", {
      key: option.value
    }, React.createElement("span", {
      className: classes.optionLabel
    }, option.label), React.createElement("br", null), React.createElement("span", null, option.value));
  }))), isConfigurable && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "flex"
  }, React.createElement("p", {
    className: "font-bold ".concat(classes.subheading)
  }, "Configured item #:"), React.createElement("p", {
    className: "ml-1 ".concat(classes.subheading)
  }, itemId)), React.createElement("div", {
    className: "flex"
  }, React.createElement("p", {
    className: "font-bold ".concat(classes.subheading)
  }, "Smart String:"), React.createElement("p", {
    className: "ml-1 ".concat(classes.subheading)
  }, smartString))), React.createElement("div", {
    className: classes.priceHolder
  }, !(pdfData !== null && pdfData !== void 0 && (_pdfData$price = pdfData.price) !== null && _pdfData$price !== void 0 && (_pdfData$price$toLowe = _pdfData$price.toLowerCase()) !== null && _pdfData$price$toLowe !== void 0 && _pdfData$price$toLowe.includes('hide')) && React.createElement(Price, {
    currencyCode: product === null || product === void 0 ? void 0 : (_product$price_range = product.price_range) === null || _product$price_range === void 0 ? void 0 : (_product$price_range$ = _product$price_range.maximum_price) === null || _product$price_range$ === void 0 ? void 0 : (_product$price_range$2 = _product$price_range$.final_price) === null || _product$price_range$2 === void 0 ? void 0 : _product$price_range$2.currency,
    value: pdfData !== null && pdfData !== void 0 && (_pdfData$price2 = pdfData.price) !== null && _pdfData$price2 !== void 0 && (_pdfData$price2$toLow = _pdfData$price2.toLowerCase()) !== null && _pdfData$price2$toLow !== void 0 && _pdfData$price2$toLow.includes('markup') ? ((pdfData === null || pdfData === void 0 ? void 0 : pdfData.pricing) || 1) * (product === null || product === void 0 ? void 0 : (_product$price_range2 = product.price_range) === null || _product$price_range2 === void 0 ? void 0 : (_product$price_range3 = _product$price_range2.maximum_price) === null || _product$price_range3 === void 0 ? void 0 : (_product$price_range4 = _product$price_range3.final_price) === null || _product$price_range4 === void 0 ? void 0 : _product$price_range4.value) : product === null || product === void 0 ? void 0 : (_product$price_range5 = product.price_range) === null || _product$price_range5 === void 0 ? void 0 : (_product$price_range6 = _product$price_range5.maximum_price) === null || _product$price_range6 === void 0 ? void 0 : (_product$price_range7 = _product$price_range6.final_price) === null || _product$price_range7 === void 0 ? void 0 : _product$price_range7.value // 1

  })), isConfigurable && selectedOptions && React.createElement("div", {
    className: classes.notifField
  }, React.createElement("img", {
    src: InfoIcon,
    alt: "Info icon"
  }), React.createElement("span", null, "Image shown may not correspond to selected options")), React.createElement("div", null)));
};

export default BaseInfo;